module.exports = __webpack_public_path__ + "assets/img/5.0f9f8025.png";